import React from 'react'

const ICONS = {
  close: (
    <>
      <path d='M6 6l12 12' />
      <path d='M18 6L6 18' />
    </>
  ),
  mail: (
    <>
      <rect x='3.5' y='5.5' width='17' height='13' rx='2' />
      <path d='m4 7 8 6 8-6' />
    </>
  ),
  user: (
    <>
      <circle cx='12' cy='8' r='3.5' />
      <path d='M5.5 19a6.5 6.5 0 0 1 13 0' />
    </>
  ),
  key: (
    <>
      <circle cx='8' cy='14' r='3.5' />
      <path d='M11 11l7-7' />
      <path d='M15 7l2 2' />
      <path d='M13 9l2 2' />
    </>
  ),
  eye: (
    <>
      <path d='M3 12s3.2-6 9-6 9 6 9 6-3.2 6-9 6-9-6-9-6Z' />
      <circle cx='12' cy='12' r='2.5' />
    </>
  ),
  eyeOff: (
    <>
      <path d='M3 12s3.2-6 9-6c1.8 0 3.3.55 4.6 1.32' />
      <path d='M21 12s-3.2 6-9 6c-1.8 0-3.3-.55-4.6-1.32' />
      <path d='M4 4l16 16' />
      <path d='M10.5 10.5a2.5 2.5 0 0 0 3 3' />
    </>
  ),
}

function AuthIcon({ name, className = '', size = 20 }) {
  return (
    <svg
      className={`auth-svg-icon ${className}`.trim()}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.9'
      strokeLinecap='round'
      strokeLinejoin='round'
      aria-hidden='true'
      focusable='false'
    >
      {ICONS[name] || ICONS.user}
    </svg>
  )
}

export default AuthIcon
